import { jsx as _jsx } from "react/jsx-runtime";
import { lazy } from "react";
import { DashboardContextProvider, useAuthContext, CONFIG_KEYS } from ".";
var InsightsDashboard = lazy(function () { return import("./InsightsDashboard.jsx"); });
var Insights = lazy(function () { return import("pages/Insights"); });
var DashboardController = function () {
    var globalConfigMap = useAuthContext().globalConfigMap;
    var newDashboardEnabled = globalConfigMap.isEnabled(CONFIG_KEYS.newDashboardEnabled, true);
    console.log("[INFO] New dashboard enabled: ".concat(newDashboardEnabled));
    return (_jsx(DashboardContextProvider, { children: _jsx(InsightsDashboard, {}) }));
};
export default DashboardController;
